import React, { useEffect, useRef, useState } from "react";
import "./Crie.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  Stack,
  Tooltip,
} from "@mui/material";
import CrieMenu from "./CrieMenu";
import phone from "../../../../Assets/phone.svg";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LinkedINImage from "../../../../Assets/linkedin.svg";
import massageicon from "../../../../Assets/FrameDiff.svg";
import company from "../../../../Assets/people-logo.png";
import education from "../../../../Assets/cap-logo.png";
import experience from "../../../../Assets/jobcompany.png";
import ReplayIcon from "@mui/icons-material/Replay";
import linkedin from "../../../../Assets/linkedin.svg";
import visitLinkImage from "../../../../Assets/visit-link.svg";
import { APIUrlThree, APIUrlToken } from "../../../../Utils/Utils";
import axios from "axios";
import { CloseOutlined } from "@mui/icons-material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useLocation, useNavigate } from "react-router-dom";
import partnerimg from "../../../../Assets/partnerimg.svg";
import joformarimg from "../../../../Assets/joformernew.svg";
import moment from "moment";

const CrieDirectPathPdf = ({}) => {
  const feedBoxOneData = localStorage.getItem("cdp");
  const feedBoxOne = JSON.parse(feedBoxOneData) || [];
  let dataForInformation = feedBoxOne?.dataForInformation;
  let crieData = feedBoxOne?.crieData;
  let organizationAssociateList = feedBoxOne?.organizationAssociateList;
  let joassociate = feedBoxOne?.joassociate;
  let organizationassociate = feedBoxOne?.organizationassociate;
  let pathWeightList = feedBoxOne?.pathWeightList;
  let pathWeight = feedBoxOne?.pathWeight;
  let joAssociateList = feedBoxOne?.joAssociateList;
  let crieSrcList = feedBoxOne?.crieSrcList;

  //    const [pathWeight, setPathWeight] = React.useState(datalocalDirect?.pathWeight || []);

  // Path Weight
  const allPathWeightdata = [
    {
      name: "Extra Strong 85-100",
      value: [85, 100],
    },
    {
      name: "Strong 71-84",
      value: [71, 84],
    },
    {
      name: "Slightly Strong 57-70",
      value: [57, 70],
    },
    {
      name: "Neutral 43-56",
      value: [43, 56],
    },
    {
      name: "Slightly Weak 29-42",
      value: [29, 42],
    },
    {
      name: "Weak 15-28",
      value: [15, 28],
    },
    {
      name: "Extra Weak 1-14",
      value: [1, 14],
    },
  ];

  const getDaysDifference = (date) => {
    const diff = moment().diff(moment(date), "days");

    if (diff >= 366) {
      return { text: "1 year+", color: "rgb(207 74 74)" };
    } else if (diff >= 181) {
      return { text: "< 1 year", color: "#EC971E" };
    } else if (diff >= 91) {
      return { text: "< 6 months", color: "#C601A2" };
    } else if (diff >= 31) {
      return { text: "< 3 months", color: "#0195C6" };
    } else {
      return { text: "< 1 month", color: "rgb(90 194 157)" };
    }
  };
const [isPortrait, setIsPortrait] = useState(false);
  useEffect(() => {
    const mediaQuery = window.matchMedia("(orientation: portrait)");
    const handleChange = (e) => {
      setIsPortrait(e.matches);
    };
    // set initial value
    setIsPortrait(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  return (
    <div>
      <div className={`crie-filter-inner-container do_not_print`}>
        <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          {/* Jo Associate */}
          <div className="crie_outer_drop">
            <div className="crie-drop-down" style={{ textTransform: "none" }}>
              JO Employee
              <KeyboardArrowDownIcon />
            </div>
            <div
            // ref={joRef}
            ></div>
          </div>

          <div className="hyphen-conn-main">
            <p className="line-hyphen-conn"></p>
            <p className="hyphen-conn">-</p>
          </div>
          {/* organization associate */}
          <div className="crie_outer_drop">
            <div className="crie-drop-down">
              {dataForInformation?.name} Employee
              <KeyboardArrowDownIcon />
            </div>
            <div></div>
          </div>
          {/* Path weight */}
          <div className="crie_outer_drop">
            <div className="crie-drop-down">
              Path Strength
              <KeyboardArrowDownIcon />
            </div>
          </div>
        </div>
      </div>
      <div className="crie-filter-inner-container cre-list-cont">
        <div className="crie-inner-drop-boxes-2">
          {joassociate?.length ? (
            <>
              {joassociate?.map((item) => (
                <div className="crie_selected_names">
                  {joAssociateList?.find((i) => i?.value == item)?.name}{" "}
                  <CloseOutlined />
                </div>
              ))}
            </>
          ) : null}
        </div>
        <div className="crie-inner-drop-boxes-2">
          {organizationassociate?.length ? (
            <>
              {organizationassociate?.map((item) => (
                <div className="crie_selected_names">
                  {
                    organizationAssociateList?.find((i) => i?.value == item)
                      ?.name
                  }{" "}
                  <CloseOutlined />
                </div>
              ))}
            </>
          ) : null}
        </div>
        <div className="crie-inner-drop-boxes-2">
          {pathWeight?.length ? (
            <>
              {pathWeight?.map((item) => (
                <div className="crie_selected_names">
                  {
                    pathWeightList?.find(
                      (i) => i?.value[0] == item[0] && i?.value[1] == item[1]
                    )?.name
                  }{" "}
                  <CloseOutlined />
                </div>
              ))}
            </>
          ) : null}
        </div>
      </div>
      {/* <div className='crie-cont crie_direct'>Direct Connection Paths</div> */}
      <div style={{ padding: isPortrait ? "0px" : "20px" }}>
        <div className="path-graph-crie">
          {/* <div className='radio-input-crie'> <div className='direct-path-crie'><input type="radio" /><p>Direct Paths</p></div> <div className='in-direct-path-crie'><input type="radio" /><p>In-Direct Paths</p></div></div> */}
          <div className="radio-input-crie">
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                className="rg-direct-paths"
              >
                <FormControlLabel
                  className="direct-path-crie"
                  value="direct"
                  control={<Radio />}
                  label="Direct Paths"
                />
              </RadioGroup>
            </FormControl>
          </div>
          {crieData?.length ? (
            <>
              {crieData
                .sort((a, b) => b.strength - a.strength)
                ?.map((item, index) => (
                  <div
                    className="crie_path_cont"
                    style={{ pageBreakInside: "avoid" }}
                  >
                    <div
                      className="first_crie_box"
                      style={{ pageBreakInside: "avoid" }}
                    >
                      <div className="crie_info">
                        <div className="crie_name">
                          {item?.src_name}{" "}
                          <p className="formerjo-p">
                            {item.src_former_jo ? (
                              <img
                                src={joformarimg}
                                alt=""
                                className="jo-former-icon"
                              />
                            ) : (
                              ""
                            )}
                          </p>{" "}
                        </div>
                        <div>Jobs Ohio</div>
                        <a
                          className="company-profile-mention"
                          href={`mailto:${
                            item?.src_email ? item?.src_email.split(",")[0] : ""
                          }`}
                          style={{ textDecoration: "none", color: "#003057" }}
                        >
                          <EmailOutlinedIcon
                            style={{
                              color: "#003057",
                              width: "15px",
                              height: "15px",
                            }}
                          />
                          {item?.src_email
                            ? item?.src_email.split(",")[0]
                            : "--"}
                        </a>
                        <a className="company-profile-mention">
                          {" "}
                          <img
                            src={phone}
                            alt=""
                            style={{ width: "13px", height: "13px" }}
                          />
                          {item?.src_phone ? item?.src_phone : "--"}{" "}
                        </a>
                        <p className="company-profile-mention-2">
                          <span>
                            <img
                              src={linkedin}
                              alt=""
                              style={{ width: "14px", height: "14px" }}
                            />
                            {item?.src_linkedin ? "Linkedin Profile" : "--"}
                          </span>
                          {item?.src_linkedin ? (
                            <a
                              href={item?.src_linkedin}
                              target="_blank"
                              className="crie-a-end"
                            >
                              {" "}
                              <img
                                src={visitLinkImage}
                                alt=""
                                style={{ width: "14px", height: "14px" }}
                              />
                            </a>
                          ) : (
                            <a></a>
                          )}{" "}
                        </p>
                      </div>
                    </div>
                    <div className="crie_line">
                      {/* {
                                                item?.last_date ?
                                                    <div className='crie-days'>{getDaysDifference(item?.last_date)}</div> : null
                                            } */}
                      {item?.last_date && item?.last_date !== "-" ? (
                        <div
                          className="crie-days"
                          style={{
                            background: getDaysDifference(item.last_date).color,
                          }}
                        >
                          {getDaysDifference(item?.last_date).text}
                        </div>
                      ) : null}
                      <div className="crie-img">
                        <Tooltip title={"Weighted Connection Strength"}>
                          <div className="weight-between-nodes-crie">
                            {item?.strength}
                          </div>
                        </Tooltip>
                        {item?.connection_types?.includes("Email") ? (
                          <Tooltip title={"Email Exchanged"}>
                            <img
                              src={massageicon}
                              alt=""
                              className="siderbar-modal-img"
                            />
                          </Tooltip>
                        ) : null}

                        {item?.connection_types?.includes("LinkedIn") ? (
                          <Tooltip title={"LinkedIn Connection"}>
                            <img
                              src={LinkedINImage}
                              alt=""
                              className="siderbar-modal-img"
                            />
                          </Tooltip>
                        ) : null}
                        {item?.connection_types?.includes("Organization") ? (
                          <Tooltip title={"Working in Same Organization"}>
                            <img
                              src={company}
                              alt=""
                              className="siderbar-modal-img"
                            />
                          </Tooltip>
                        ) : null}

                        {item?.connection_types?.includes("Education") ? (
                          <Tooltip title={"Attended Same College"}>
                            <img
                              src={education}
                              alt=""
                              className="siderbar-modal-img"
                            />
                          </Tooltip>
                        ) : null}

                        {item?.connection_types?.includes("Experience") ? (
                          <Tooltip
                            title={"Previously Worked in Same Organization"}
                          >
                            <img
                              src={experience}
                              alt=""
                              className="siderbar-modal-img"
                            />
                          </Tooltip>
                        ) : null}

                        {item?.connection_types?.includes("Meeting") ? (
                          <Tooltip title={"Meeting"}>
                            <CalendarMonthIcon className="siderbar-modal-img" />
                          </Tooltip>
                        ) : null}
                        {item?.connection_types?.includes("Partner") ? (
                          <Tooltip title={"Regional Partner"}>
                            <img
                              src={partnerimg}
                              alt=""
                              className="siderbar-modal-img"
                            />
                          </Tooltip>
                        ) : null}
                      </div>
                    </div>
                    <div className="first_crie_box">
                      <div className="crie_info">
                        <div className="crie_name">
                          {item?.dst_name}{" "}
                          <p className="formerjo-p">
                            {item.dst_former_jo ? (
                              <img
                                src={joformarimg}
                                alt=""
                                className="jo-former-icon"
                              />
                            ) : (
                              ""
                            )}
                          </p>{" "}
                        </div>
                        <div className="crie_name">
                          {dataForInformation?.name}
                        </div>
                        <a
                          className="company-profile-mention"
                          href={`mailto:${
                            item?.dst_email ? item?.dst_email : ""
                          }`}
                          style={{ textDecoration: "none", color: "#003057" }}
                        >
                          <EmailOutlinedIcon
                            style={{
                              color: "#003057",
                              width: "15px",
                              height: "15px",
                            }}
                          />
                          {item?.dst_email ? item?.dst_email : "--"}
                        </a>

                        <a className="company-profile-mention">
                          {" "}
                          <img
                            src={phone}
                            alt=""
                            style={{ width: "13px", height: "13px" }}
                          />
                          {item?.dst_phone ? item?.dst_phone : "--"}
                        </a>
                        <p className="company-profile-mention-2">
                          <span>
                            <img
                              src={linkedin}
                              alt=""
                              style={{ width: "14px", height: "14px" }}
                            />
                            {item?.dst_linkedin ? "Linkedin Profile" : "--"}
                          </span>{" "}
                          {item?.dst_linkedin ? (
                            <a
                              href={item?.dst_linkedin}
                              className="crie-a-end"
                              target="_blank"
                            >
                              {" "}
                              <img
                                src={visitLinkImage}
                                alt=""
                                style={{ width: "14px", height: "14px" }}
                              />
                            </a>
                          ) : null}{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
            </>
          ) : (
            <div className="crie_path_cont">No Records Found !</div>
          )}
        </div>
      </div>
    </div>
  );
};
export default CrieDirectPathPdf;
